import { render, staticRenderFns } from "./VTableDerivations.vue?vue&type=template&id=28f3985c"
import script from "./VTableDerivations.vue?vue&type=script&lang=js"
export * from "./VTableDerivations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports